import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Input } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import scss from './CsFakePasswordInput.scss';
/**
 * "假密码框"：外观和交互（明文/密文切换）与 antd Input.Password 一致，
 * 但底层始终是 type="text"，视觉遮罩通过 CSS `-webkit-text-security` 实现，
 * 不会在 DOM 中出现 type="password" 的 input。
 *
 * 用途：规避 Chrome 密码管理器"文本框 + 密码框同处一个表单"的登录表单启发式判断——
 * 该判断的核心信号就是 DOM 里是否存在 input[type=password]，本组件从根上消除这个信号，
 * 避免 Chrome 弹出"是否保存密码"，进而在下次打开页面时把保存的账号错误回填到旁边的文本框里。
 *
 * 限制：`-webkit-text-security` 是非标准属性，仅 WebKit/Blink 内核浏览器（Chrome/Edge/Safari）支持；
 * 不支持的浏览器（如 Firefox）会退化为明文显示，不影响功能，仅无遮罩效果。
 */
const CsFakePasswordInput = React.forwardRef((props, ref) => {
    const { value, onChange, placeholder, autoComplete = 'off', name, disabled, style, className, ...restProps } = props;
    const [visible, setVisible] = useState(false);
    return (_jsx(Input, { ref: ref, value: value, onChange: onChange, placeholder: placeholder, autoComplete: autoComplete, name: name, disabled: disabled, className: `${!visible ? scss.csFakePasswordInputMasked : ''} ${className || ''}`, style: style, suffix: visible
            ? _jsx(EyeOutlined, { onClick: () => setVisible(false), style: { cursor: 'pointer', color: 'rgba(0, 0, 0, 0.45)' } })
            : _jsx(EyeInvisibleOutlined, { onClick: () => setVisible(true), style: { cursor: 'pointer', color: 'rgba(0, 0, 0, 0.45)' } }), ...restProps }));
});
CsFakePasswordInput.displayName = 'CsFakePasswordInput';
export default CsFakePasswordInput;
